import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {Commune, Departement, GrhumService, Pays, Rne} from '../../grhum';
import {Response} from '@angular/http';


@Component({
    selector: 'jhi-adresse-component',
    templateUrl: './adresse.component.html'
})
export class AdresseComponent implements OnInit, OnChanges {

    @Input() translationKey: string;

    @Input() pays: string;
    @Output() paysChange: EventEmitter<string> = new EventEmitter();

    @Input() dept: string;
    @Output() deptChange: EventEmitter<string> = new EventEmitter();

    @Input() ville: string;
    @Output() villeChange: EventEmitter<string> = new EventEmitter();

    @Input() rne: string;
    @Input() rneAutre: string;
    @Input() showRne: Boolean;
    @Output() rneChange: EventEmitter<string> = new EventEmitter();
    @Output() rneAutreChange: EventEmitter<string> = new EventEmitter();

    @Input() paysListe: Pays[];
    @Input() deptListe: Departement[];
    @Input() cols: number; // Largeur des colonnes
    @Input() isEditable: Boolean;

    private typeEtablissement: String;

    public get typeEtab(): String {
        return this.typeEtablissement;
    }

    @Input()
    public set typeEtab(typeEtab: String) {
        this.typeEtablissement = typeEtab;
        this.refreshList();
    }

    villesListe: Commune[];
    rneListe: Rne[];

    constructor(public grhumService: GrhumService) {
    }

    ngOnInit() {
        this.refreshList();
    }

    private refreshList() {

        if (this.pays) {
            // liste des etablissements francais
            if (this.pays === '100' && this.dept && this.showRne && this.typeEtab !== 'EFE') {
                this.getRnes({codePostal: this.dept});
            }
            // liste des villes
            if (this.pays === '100' && this.dept) {
                this.getVilles(this.dept);
            }
        }
        // liste des etablissements à l'étranger
        if (this.showRne && this.typeEtab === 'EFE') {
            this.getRnes({typeEtabCode: this.typeEtab});
        }

    }

    ngOnChanges() {
        // this.refreshList();
    }

    onChangePays(newPays) {
        this.ville = null;
        this.villesListe = null;
        this.dept = null;
        this.rne = null;
        this.rneListe = null;
        this.refreshList();
        this.villeChange.emit(this.ville);
        this.rneChange.emit(this.rne);
        this.deptChange.emit(this.dept);
        this.paysChange.emit(newPays);
    }

    onChangeDept(newDept) {
        this.ville = null;
        this.rne = null;
        this.refreshList();
        this.villeChange.emit(this.ville);
        this.rneChange.emit(this.rne);
        this.deptChange.emit(newDept);
        this.paysChange.emit(this.pays);
    }

    onChangeVille(newVille) {
        this.villeChange.emit(newVille);
    }

    onChangeRne(newRne) {

        let idx = this.rneListe.findIndex(rne => rne.value === newRne);
        if (idx >= 0) {
            this.ville = this.rneListe[idx].codeInsee;
        } else {
            this.ville = null;
        }
        this.villeChange.emit(this.ville);
        this.rneChange.emit(newRne);

    }

    onChangeRneAutre(newRne) {
        this.rneAutreChange.emit(newRne);
    }

    private getVilles(dept) {
        this.grhumService.queryCommune({departement: dept}).subscribe(
            (res: Response) => {
                this.villesListe = res.json();
            });
    }

    private getRnes(param: any) {
        this.grhumService.queryRne(param).subscribe(
            (res: Response) => {
                this.rneListe = res.json();
            });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/adresse/adresse.component.ts